import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";
import { ESRManpowerColumns } from "../ESR/ESR-Manpower/utils/types";
import { ESREquipmentServiceColumns } from "../ESR/ESR-EquipmentService/utils/types";
import { EmailPartsList } from "../ESR/Email-Parts-List/utils/types";

interface ESRApprovalContext {
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  openManhourDialog: boolean;
  setOpenManhourDialog: Dispatch<SetStateAction<boolean>>;
  currentManhourSelected: ESRManpowerColumns;
  setCurrentManhourSelected: Dispatch<SetStateAction<ESRManpowerColumns>>;
  mHActionType: string;
  setMhActionType: Dispatch<SetStateAction<string>>;
  openMhDeleteDialog: boolean;
  setOpenMhDeleteDialog: Dispatch<SetStateAction<boolean>>;
  openESDialog: boolean;
  setOpenESDialog: Dispatch<SetStateAction<boolean>>;
  currentESSelected: ESREquipmentServiceColumns;
  setCurrentESSelected: Dispatch<SetStateAction<ESREquipmentServiceColumns>>;
  eSActionType: string;
  setESActionType: Dispatch<SetStateAction<string>>;
  openESDeleteDialog: boolean;
  setOpenESDeleteDialog: Dispatch<SetStateAction<boolean>>;
  esrManpowerArray: ESRManpowerColumns[];
  setEsrManpowerArray: Dispatch<SetStateAction<ESRManpowerColumns[]>>;
  esrEquipmentServicesArray: ESREquipmentServiceColumns[];
  setEsrEquipmentServicesArray: Dispatch<
    SetStateAction<ESREquipmentServiceColumns[]>
  >;
  partsListArray: EmailPartsList[];
  setPartsListArray: Dispatch<SetStateAction<EmailPartsList[]>>;
  esrActionType: string;
  setESRActionType: Dispatch<SetStateAction<string>>;
  openEmailSendingDialog: boolean;
  setOpenEmailSendingDialog: Dispatch<SetStateAction<boolean>>;
  isViewOnly: boolean;
  setViewOnly: Dispatch<SetStateAction<boolean>>;
  esrArray: any[];
  setEsrArray: Dispatch<SetStateAction<any[]>>;
}

const ESRApprovalContext = createContext<ESRApprovalContext | undefined>(
  undefined
);

export const ESRApprovalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openManhourDialog, setOpenManhourDialog] = useState<boolean>(false);
  const [currentManhourSelected, setCurrentManhourSelected] =
    useState<ESRManpowerColumns>({
      id: "",
      manHours: 0,
      mechanicId: "",
      mechanicName: "",
    });
  const [mHActionType, setMhActionType] = useState<string>("new");
  const [openMhDeleteDialog, setOpenMhDeleteDialog] = useState<boolean>(false);
  const [currentESSelected, setCurrentESSelected] =
    useState<ESREquipmentServiceColumns>({
      id: "",
      taskItem: "",
      taskTypeId: "",
      taskTypeItem: "",
      partNumber: "",
      quantity: "",
      remarks: "",
    });
  const [eSActionType, setESActionType] = useState<string>("new");
  const [openESDeleteDialog, setOpenESDeleteDialog] = useState<boolean>(false);
  const [openESDialog, setOpenESDialog] = useState<boolean>(false);
  const [openEmailSendingDialog, setOpenEmailSendingDialog] =
    useState<boolean>(false);
  const [isViewOnly, setViewOnly] = useState<boolean>(true);
  const [esrManpowerArray, setEsrManpowerArray] = useState<
    ESRManpowerColumns[]
  >([]);
  const [esrEquipmentServicesArray, setEsrEquipmentServicesArray] = useState<
    ESREquipmentServiceColumns[]
  >([]);
  const [partsListArray, setPartsListArray] = useState<EmailPartsList[]>([]);
  const [esrActionType, setESRActionType] = useState<string>("");
  const [esrArray, setEsrArray] = useState<any[]>([]);

  return (
    <ESRApprovalContext.Provider
      value={{
        openDialog,
        setOpenDialog,
        openManhourDialog,
        setOpenManhourDialog,
        currentManhourSelected,
        setCurrentManhourSelected,
        mHActionType,
        setMhActionType,
        openMhDeleteDialog,
        setOpenMhDeleteDialog,
        openESDialog,
        setOpenESDialog,
        currentESSelected,
        setCurrentESSelected,
        eSActionType,
        setESActionType,
        openESDeleteDialog,
        setOpenESDeleteDialog,
        openEmailSendingDialog,
        setOpenEmailSendingDialog,
        esrManpowerArray,
        setEsrManpowerArray,
        esrEquipmentServicesArray,
        setEsrEquipmentServicesArray,
        partsListArray,
        setPartsListArray,
        esrActionType,
        setESRActionType,
        isViewOnly,
        setViewOnly,
        esrArray,
        setEsrArray,
      }}
    >
      {children}
    </ESRApprovalContext.Provider>
  );
};

export const useESRApprovalContext = (): ESRApprovalContext => {
  const context = useContext(ESRApprovalContext);
  if (!context) {
    throw new Error(
      "useESRApprovalContext must be used within a ESRApprovalProvider"
    );
  }
  return context;
};
